import { IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GenerateIcon from '../GenerateIcon'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import ScanQRCode from '../../features/items/ScanQRCode'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DateAndTime from '../../features/DateAndTime'

export default function DateAndTimeField(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, handleOnChange, data, multiline, maxRows, minRows, handleKeyUp, enableQrCodeScanner, validateInput, placeholder, defaultValue } = props

    const dispatch = useDispatch()

    const [fieldType, setFieldType] = useState<string>(props.fieldType ? props.fieldType : "text")

    let inputProps = {}

    const dateAndTime = new DateAndTime()

    const returnCurrentValue = () => {
        let value: string = ""

        if (defaultValue){
            value = defaultValue
        }

        if (data.value){
            value = data.value
        }

        return value
    }

    return(
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                label={label}
                value={new Date(returnCurrentValue())}
                onChange={(value, context) => {
                    handleOnChange(id, value ? dateAndTime.formatToServerStandart(value.toString()) : value)
                }}
                slots={{
                    textField: (props) => <TextField {...props} variant="outlined" fullWidth />,
                }}
            />
            <p onClick={() => handleOnChange(id, dateAndTime.formatToServerStandart(new Date().toString()) )} className="form-elemt-link-button-text">Current Date</p>
        </LocalizationProvider>
    )
    return(
        <>
            <TextField 
                    id={id} 
                    error={data.helperTextType == "error" ? true : false} 
                    type={fieldType} 
                    label={label} 
                    placeholder={placeholder}
                    variant="outlined" 
                    fullWidth={fullWidth} 
                    value={data.value} 
                    onChange={(e) => handleOnChange(id, e.target.value)} 
                    InputProps={inputProps} 
                    multiline={multiline}
                    maxRows={maxRows}
                    minRows={minRows}
                    onKeyUp={(e: React.KeyboardEvent<HTMLDivElement>) => {
                        if (handleKeyUp){
                            handleKeyUp(e)
                        }
                    }}        
            />
        </>
    )
}